import * as Sentry from "@sentry/react";

// Determine environment
const environment = process.env.REACT_APP_ENVIRONMENT || 
                   (window.location.hostname === 'localhost' ? 'development' : 
                    window.location.hostname.includes('preview') ? 'preview' : 'production');

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN || "https://5cc2958c840311c0629770c09b685782@o4510279144112128.ingest.us.sentry.io/4510394283393024",
  
  environment: environment,
  release: process.env.REACT_APP_VERSION || "1.0.0",
  
  integrations: [
    Sentry.browserTracingIntegration({
      // Disable automatic fetch instrumentation to avoid Response body conflicts
      instrumentNavigation: false,
      instrumentPageLoad: false,
    }),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  
  // Performance Monitoring - 100% in production, 50% in dev
  tracesSampleRate: environment === 'production' ? 1.0 : 0.5,
  
  // Session Replay
  replaysSessionSampleRate: environment === 'production' ? 0.1 : 0.0,
  replaysOnErrorSampleRate: 1.0,
  
  // Enable debug in development
  debug: environment === 'development',
  
  // Capture unhandled promise rejections
  beforeSend(event, hint) {
    // Filter out 404 errors from public routes
    if (event.exception && event.exception.values) {
      const error = event.exception.values[0];
      if (error.value && error.value.includes('404')) {
        return null;
      }
    }
    
    // Don't capture session check errors (expected when not logged in)
    if (event.request && event.request.url && event.request.url.includes('/api/auth/session')) {
      return null;
    }
    
    return event;
  },
});

export default Sentry;
